import actions from "@/store/analyst/actions";
import getters from "@/store/analyst/getters";
import mutations from "@/store/analyst/mutations";
import state from "@/store/analyst/state";

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
